import { render, staticRenderFns } from "./ArticleList.vue?vue&type=template&id=683fb8ef&scoped=true&"
import script from "./ArticleList.vue?vue&type=script&lang=js&"
export * from "./ArticleList.vue?vue&type=script&lang=js&"
import style0 from "./ArticleList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ArticleList.vue?vue&type=style&index=1&id=683fb8ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683fb8ef",
  null
  
)

export default component.exports